<template>
  <div>
    <header-tab :tabs="activityTab" :activity="activeData.activityType" tabDisplayName="Name"
      activeProp="Id" @onTab="onTab" />

    <div class="activity" v-if="activeList.length>0">
      <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading"
        infinite-scroll-distance="20">
        <li v-for="item in activeList" :key="item.ID">
          <router-link :to="{name:'activity-detail',params: {id: item.ID}}">
            <div class="img">
              <!-- +'?x-oss-process=image/resize,m_fill,h_132,w_200' -->
              <img :src="item.TitleImagePath?item.TitleImagePath:defaultImg" :onerror="defaultImg"
                alt>
            </div>
            <div class="main-content">
              <h5>{{item.Title}}</h5>
              <span>时间：{{item.ActivityStartTimeTXT}}</span>
              <span>地点：{{item.ProvinceName}}{{item.CityName}}</span>
            </div>
          </router-link>
          <div class="btn-main label">{{item.ActTypeName}}</div>
        </li>
      </ul>
      <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
    </div>
    <empty v-if="isEmpty"></empty>
    <footer-logo></footer-logo>
    <footer-nav :name="name"></footer-nav>
  </div>
</template>

<script>
  import footerNav from '@/views/footerNav.vue'
  import footerLogo from '@/components/footerLogo.vue'
  import empty from '@/views/statePage/empty.vue'
  import HeaderTab from '@/components/HeaderTab.vue'

  export default {
    components: {
      'footer-nav': footerNav,
      'footer-logo': footerLogo,
      HeaderTab,
      empty
    },
    data() {
      return {
        name: {
          name: '活动'
        },
        tabNum: -1,
        pageHint: '',
        activityTab: [],
        activeList: [],
        activeData: {
          title: '',
          activityType: 0,
          pageIndex: 1,
          pageSize: 10
        },
        totalPage: -1,
        isEmpty: false,
        loading: false,
        defaultImg: 'http://image.gongyila.com/org/1/album/2018/09/01d34f33d65440c58d11d1802f3c1cc7.png?x-oss-process=image/resize,m_fill,h_66,w_100'
      }
    },
    created() {
      this.getActivityType()
        .then(() => {
          this.loading = true
          this.getActList()
        })
        .catch(err => {})
    },
    methods: {
      getActivityType() {
        var queryActType = this.$route.query.type
        return new Promise((resolve, reject) => {
          this.$fetch('/api/Common/GetDicList?value=ActivityType')
            .then(result => {
              this.activityTab = result
              if (queryActType && this.activityTab !== null && this.activityTab.length > 0) {
                for (let i = 0; i < this.activityTab.length; i++) {
                  let item = this.activityTab[i]
                  if (item.Name === queryActType) {
                    this.activeData.activityType = item.Id
                    this.tabNum = i
                    break
                  }
                }
              }
              resolve()
            })
            .catch(err => {
              console.log('getDicList?ActivityType')
              reject(err)
            })
        })
      },
      getActList() {
        this.pageHint = '加载中...'
        var _this = this
        this.$fetch('/api/Activity/GetActivityList', this.activeData).then(result => {
          _this.totalPage = result.PageCount
          if (this.activeData.pageIndex >= this.totalPage) {
            this.pageHint = '没有更多了'
          } else {
            this.pageHint = '上拉加載更多'
          }
          if (result.Items && result.Items.length > 0) {
            this.activeList = this.activeList.concat(result.Items)
            this.isEmpty = false
          } else {
            this.activeList = []
            this.isEmpty = true
            this.pageHint = ''
          }
          this.loading = false
        })
      },
      loadMore() {
        if (this.activeData.pageIndex >= this.totalPage) {
          this.loading = false
        } else {
          this.loading = true
          this.pageHint = '加载中...'
          setTimeout(() => {
            this.activeData.pageIndex++
            this.getActList()
          }, 1500)
        }
      },
      onTab(activityType) {
        if (activityType !== this.activeData.activityType) {
          this.activeData.pageIndex = 1
          this.activeData.activityType = activityType
          this.activeList = []
          this.totalPage = -1
          this.getActList()
        }
      }
    }
  }

</script>

<style lang="less" scoped>
  #success {
    background: #f7f7f7 !important;
  }

  .activity {
    width: 100%;
    height: auto;

    ul {
      padding: 25 / @rem-size 24 / @rem-size 0 24 / @rem-size;
      background: #fff;
      border-bottom: 10 / @rem-size solid #f7f7f7;

      li {
        display: flex;
        margin-top: 25 / @rem-size;
        padding-bottom: 25 / @rem-size;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        .label {
          width: auto;
          height: 40 / @rem-size;
          font-size: 24 / @rem-size;
          text-align: center;
          line-height: 40 / @rem-size;
          position: absolute;
          top: 16 / @rem-size;
          left: 0;
          margin: auto;
          padding: 0 10/@rem-size;
        }

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          border: none;
        }

        a {
          display: flex;
        }

        .img {
          width: 200 / @rem-size;
          height: 132 / @rem-size;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .main-content {
          flex: 1;
          margin-left: 22 / @rem-size;

          h5 {
            font-size: 0.3rem;
            color: #333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 4.9rem;
            font-weight: 500;
          }

          span {
            display: block;
            margin-top: 10 / @rem-size;
            color: #999;
            font-size: 28 / @rem-size;
          }
        }
      }
    }
  }

</style>
